import { FunctionComponent } from 'react';
import { Stack, Tag } from '@shopify/polaris';
import styled from 'styled-components';

const TagContainer = styled.div<{ disabled?: boolean }>`
  .Polaris-Tag {
    color: ${({ disabled, theme }) =>
      disabled ? theme.colors.secondary.hex : 'inherit'};
  }
`;

const TagsStack: FunctionComponent<{
  disabled?: boolean;
  initialSelected: string[];
  onCancel: (tag: string) => void;
}> = ({ disabled, initialSelected = [], onCancel }) => {
  const onClickCancel = (tag: string) => {
    if (onCancel) {
      onCancel(tag);
    }
  };

  return (
    <Stack>
      <TagContainer disabled={disabled}>
        {initialSelected.map((tag) => (
          <Tag key={tag} onRemove={() => onClickCancel(tag)}>
            {tag}
          </Tag>
        ))}
      </TagContainer>
    </Stack>
  );
};

export default TagsStack;
